(function(){
  'use strict';
angular.module("irricrops")
  .factory("Config", ["$rootScope", "$timeout","temporadaFac",  function($rootScope, $timeout, temporadaFac){

    //icono de descarga
    //http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/exporting/buttons-contextbutton-symbol-custom/
    Highcharts.SVGRenderer.prototype.symbols.download = function (x, y, w, h) {
      var path = [
        // Arrow stem
        'M', x + w * 0.5, y,
        'L', x + w * 0.5, y + h * 0.7,
        // Arrow head
        'M', x + w * 0.3, y + h * 0.5,
        'L', x + w * 0.5, y + h * 0.7,
        'L', x + w * 0.7, y + h * 0.5,
        // Box
        'M', x, y + h * 0.9,
        'L', x, y + h,
        'L', x + w, y + h,
        'L', x + w, y + h * 0.9
      ];
      return path;
    };

    var colors = {
      "fenologia":{
        weekend: "rgba(94,53,177,0.3)" //deep-purple 600
      },
      //COLOR datos de riego
      "sensores":{
        weekend: "rgb(209,196,233)",
      },
      "scholander":{
        background: "#F57C00" /* orange 700 */,
        weekend: "rgba(230,81,0,0.3)",//orange 900
        array:[
          '#E65100', //orange 900
          "#1e88e5", // blue 600
          "#43a047", // green  600
          "#b71c1c", // red 900
        ],
        _array:[
          '#E65100', //orange 900
          '#F57C00', // orange 700
          '#FF9800', // orange 500
          '#FFA726', // orange 400
        ]
      },
      "porometro":{
        background: "#00796b" /* teal 700 */,
        weekend: "rgba(0,77,64,0.3)"// teal 900
      },
      "sensorSuma":{
        background:"#7b1fa2"// purple 700
      },
      "sensor1":{
        background: "#F50057" /* pink a400 */
      },
      "sensor2":{
        background: "#00C853" /* green a700 */
      },
      "sensor3":{
        background: "#8C9EFF" /* indigo a100 */
      },
      "riegoProgramado":{
        background: "#689F38", /* light green 700 */
        weekend: "rgba(0,137,123,0.3)",//teal 600
        array:[
          '#558B2F', //light green 800
          "#b71c1c", // red 900
          "#1e88e5", // blue 600
          "#43a047" // green  600
        ],
        _array:[
          '#558B2F', //light green 800
          '#689F38', //light green 700
          '#8BC34A', //light green 500
          '#9CCC65', //light green 400
        ]
      },
      "riegoIdeal":{
        background: "#9fa8da" /* indigo 500 */
      },
      "riegoReal":{
        background: "#3F51B5", /* indigo 500 */
        weekend: "rgba(13,71,161,0.3)", //blue 900
        contrast: '#43a047', /* green 600 */
        before: "#fbc02d", /*yellow 700*/
        array:[
          "#0d47a1", // blue 900
          "#b71c1c", // red 900
          "#43a047", // green  600
          "#1e88e5", // blue 600
        ],
      },
      "crecimientoFruto":{
        weekend: "rgba(94,53,177,0.3)" //deep-purple 600
      },
      "promedioReposicion":{
        array:[
          '#29b6f6', // litgh blue 400
          '#03a9f4', // litgh blue 500
          '#039be5', // litgh blue 600
          '#0288d1', // litgh blue 700
        ],
      },
      "porcentajeIdeal":{
        //background: "#9fa8da" /* indigo 500 */
        background: "#ef6c00",
        contrast:"#4caf50", // green 500

        array:[
          '#E65100', //orange 900
          "#1e88e5", // blue 600
          "#43a047", // green  600
          "#b71c1c", // red 900
        ],
        _array:[
          '#E65100', //orange 900
          '#F57C00', // orange 700
          '#FF9800', // orange 500
          '#FFA726', // orange 400
        ]
      },
      "porcentajeReal":{
        background: "#3F51B5", /* indigo 500 */
        contrast:"#1b5e20", // green 900
        markerBorder: "#FFFFFF",
        markerColor : "#3F51B5" /* indigo 500 */
      },
      "produccionReal":{
        background:"#7b1fa2"// purple 700
      },
      "precipitacion":{
        background: "#9c27b0",
      },
      "gd":{
        background: "#B71C1C", /* red 900 */
        array:[
          "#b71c1c", // red 900
          "#1e88e5", // blue 600
          "#43a047" // green  600
        ]
      },
      "winkler":{
        array:[
          "#0d47a1", // blue 900
          "#b71c1c", // red 900
          "#43a047", // green  600
          "#1e88e5", // blue 600
        ],
      },
      "temperatura":{
        background: "#B71C1C" /* red 900 */,
        min:"#ff7043", //deep orange 400
        med: "#ff5722", //deep orange 500
        max:"#B71C1C" /* red 900 */,
      },
      "volumen":{
        //background: "#1565c0" /* blue 800*/
        background: '#2E7D32', /* green 800 */
        array:[
          '#2E7D32', /* green 800 */
          "#b71c1c", // red 900
          "#1e88e5", // blue 600
          "#43a047" // green  600
        ],
        _array:[
          '#2E7D32', /* green 800 */
          '#43a047', /* green 600 */
          '#66BB6A', /* green 400 */
          '#81C784', /* green 300 */
        ]
      },
      "etb":{
        background: "#0091EA", /* light blue a700 */
        alt: "#ff9100", // orange A400
        array:[
          '#0D47A1', //blue 900
          "#b71c1c", // red 900
          "#43a047", // green  600
          "#1e88e5"  // blue 600
        ],
        _array:[
          '#0D47A1', //blue 900
          '#1976D2', //blue 700
          '#2196F3', //blue 500
          '#42A5F5', //blue 400
        ]
      },
      "et0":{
        background: "#00838F", /*cyan 800*/
        alt: "#ff6d00", //orange A700
        array:[
          '#006064', // cyan 900
          "#b71c1c", // red 900
          "#1e88e5", // blue 600
          "#43a047" // green  600
        ],
        _array:[
          '#006064', // cyan 900
          '#00838F', // cyan 800
          '#00ACC1', // cyan 600
          '#26C6DA', // cyan 400
        ]
      },
      "etc":{
        //background: "#ba68c8" /* purple 300*/
        background: '#43a047' /* green 600 */
      },


      "etSimulado":{
        background: "#ec407a" /* pink 400 */
      },
      "etAcum":{
        //background: "#0091EA" /* light blue a700 */
        background: '#43a047' /* green 600 */
      },
      "etAcumulado":{
        background: "#0091EA" /* light blue a700 */
      },
      "riegoSimulado":{
        background:"#ec407a" // pink 500
      },



      //COLOR unidades genericas
      "porcentaje":{
        //background:"#ffa000" //amber 700
        background: "#3F51B5", /* indigo 500 */
      },
      "kilogramos":{
        background:"#1976d2" //blue 700
      },
      "toneladas":{
        background:"#00796b" //teal 700
      },
      "metros":{
        background:"#ef5350" //red 400
      },


      //COLOR unidades productivas (usadas en grafico de resumen)
      "porcentaje_reposicion":{
        background:"#ef5350" //red 400
      },
      "metros_hectareas":{
        background:"#ef5350" //red 400
      },
      "peso_poda_metro":{
        background:"#1976d2" //blue 700
      },
      "produccion_toneladas_ha":{
        background:"#7b1fa2"// purple 700
      },
      "produccion_toneladas_ha_esperado":{
        background:"#ce93d8"// purple 200
      },
      "porcentaje_n":{
        background:"#ffa000" //amber 700
      },
      "unidad_n":{
        background:"#ffa000" //amber 700
      },
      "vigor":{
        background:"#a5d6a7" // green 200
      },
      "novigor":{
        background:"#ffcdd2" // red 100
      },



      //COLOR etapas productivas
      "ravaz": {
        background: "#ff5722" /*deep orange 500*/
      },
      "pesoPoda": {
        background: "#00838F" /*cyan 800*/
      },
      "bayas": {
        background: "#5E35B1" /*deep purple 600*/
      },
      "produccion": {
        //background: "#00C853" /* green a700 */
        background: "#9c27b0" // purple 500
      },

      "gramos": {
        background: "#7e57c2" /* deep-purple 400*/
      },
      "calibre": {
        background: "#4527a0" /* deep-purple 800*/
      },


      "grey":{
        background: "#e0e0e0",
        border: "#e0e0e0"
      },
      "ur":{
        background: "#f44336", /*red 500*/
      },
      "saturacion":{
        background: "#2196f3", /*blue 500*/
        backgroundRGBA: "rgba(33,150,243,0.3)",
        border: "#1976d2" /*blue 700*/
      },
      "cc":{
        background: "#4caf50", //green 500
        backgroundRGBA: "rgba(76,175,80,0.3)",
        border: "#388e3c" //green 700
      },
      "pmp":{
        background: "#f44336", /*red 500*/
        backgroundRGBA:"rgba(244,67,54,0.3)",
        border: "#b71c1c" /*red 900*/
      },

      //COLOR etapas fenologicas
      "etapa1": {
        background: "#FCE4EC", /*pink 50*/
        border: "#F06292" /*pink 300*/
      },
      "etapa2": {
        background: "#E0F2F1", /*teal 50*/
        border: "#4DB6AC" /*teal 300*/
      },
      "etapa3": {
        background: "#EDE7F6", /*purple 50*/
        border: "#BA68C8" /*purple 300*/
      },
      "etapa4": {
        background: "#E8F5E9", /*green 50*/
        border: "#81C784" /*green 300*/
      },

      list:[
        "#8BC34A",
        "#3F51B5",
        "#F44336",
        "#9C27B0",
        "#607D8B",
        "#03A9F4",
        "#795548",
        "#FF5722",
        "#2196F3",
        "#FFEB3B",
        "#00BCD4",
        "#4CAF50",
        "#673AB7",
        "#E91E63",
        "#CDDC39",
        "#FFC107",
        "#009688",
        "#FF9800",
        "#9E9E9E",
      ]
    };








    var formatYAxis = function(yAxisOriginal){
      var yAxis = angular.copy(yAxisOriginal);
      _.each(yAxis, function(ya, index){
        ya.visible = false;
        ya.id = index;
      });
      return yAxis;
    }

    var yAxisConfig = [

      { // Primary yAxis
        // id:0,
        alignTicks: false,
        gridLineWidth: 0,
        gridLineColor: 'transparent',//colors.temperatura.background,
        labels: {
          format: '{value}',
          style: {
            // color: colors.temperatura.background
          }
        },
        title: {
          text: 'Temperatura (°C)',
          style: {
            // color: colors.temperatura.background
          }
        },
        opposite: true,

      }, { // Tertiary yAxis
        // id: 1,
        alignTicks: false,
        tickInterval: 5,
        min: 0,
        ceiling: 25,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        title: {
          text: 'Bares de presion (negativos)',
          style: {
            // color: colors.scholander.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            // color: colors.scholander.background
          }
        },
      },
      { // Secondary yAxis
        //id: 2,
        alignTicks: false,
        softMax: 50,
        //gridLineWidth: 1,
        //gridLineColor: colors.riegoReal.background,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        title: {
          text: 'Milimetros de Agua (mm)',
          style: {
            // color: colors.riegoReal.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.riegoReal.background
          }
        },

      },




      {
        //id:3,
        alignTicks: false,
        gridLineWidth: 0,
        gridLineColor: 'transparent', //colors.sensor1.background,
        softmin: 20,
        //max: 90,
        startOnTick: false,
        endOnTick: false,
        tickInterval: 5,
        opposite: true,
        title: {
          text: 'Humedad (% Porcentaje)',
          style: {
            //color: colors.sensor1.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.sensor1.background
          }
        },
      },

      {
        //id:4,
        alignTicks: false,
        //gridLineWidth: 1,
        //gridLineColor: colors.porcentaje.background,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        //min: -100,
        //max: 50,
        title: {
          text: 'Porcentaje (%)',
          style: {
            //color: colors.porcentaje.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.porcentaje.background
          }
        },
      },
      {
        //id:5,
        alignTicks: false,
        //gridLineWidth: 1,
        //gridLineColor: colors.kilogramos.background,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        title: {
          text: 'Kilogramos (Kg)',
          style: {
            //color: colors.kilogramos.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.kilogramos.background
          }
        },
        opposite: true,
      },
      {
        //id:6,
        alignTicks: false,
        //gridLineWidth: 1,
        //gridLineColor: colors.toneladas.background,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        title: {
          text: 'Toneladas (ton) / ha',
          style: {
            //color: colors.toneladas.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.toneladas.background
          }
        },
        opposite: true,
      },
      {
        //id:7,
        alignTicks: false,
        //gridLineWidth: 1,
        //gridLineColor: colors.metros.background,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        title: {
          text: 'Metros Cúbicos (m<sup>3</sup>)',
          style: {
            //color: colors.metros.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.metros.background
          }
        },
      },


      {
        //id:8,
        alignTicks: false,
        //gridLineWidth: 1,
        //gridLineColor: colors.pesoPoda.background,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        min: 0,
        title: {
          text: 'Peso poda (kg/mts)',
          style: {
            //color: colors.pesoPoda.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.pesoPoda.background
          }
        },
      },
      {
        //id:9,
        alignTicks: false,
        //gridLineWidth: 1,
        //gridLineColor: colors.bayas.background,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        min: 0,
        title: {
          text: 'Bayas (Cantidad)',
          style: {
            //color: colors.bayas.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.bayas.background
          }
        },
        opposite: true,
      },
      {
        //id:10,
        alignTicks: false,
        //gridLineWidth: 1,
        //gridLineColor: colors.produccion.background,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        min: 0,
        title: {
          text: 'Produccion',
          style: {
            //color: colors.produccion.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.produccion.background
          }
        },
      },
      {
        //id:11,
        alignTicks: false,
        //gridLineWidth: 1,
        //gridLineColor: colors.ravaz.background,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        min: 0,
        title: {
          text: 'Ravaz (indice)',
          style: {
            //color: colors.ravaz.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.ravaz.background
          }
        },
        opposite: true,
      },
      {
        //id:12,
        alignTicks: false,
        //min: 0,
        //softMax: 100,
        //gridLineWidth: 1,
        //gridLineColor: colors.porcentaje.background,
        exporting:{
          softMax: 100,
        },
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        title: {
          text: 'Porcentaje (%)',
          style: {
            //color: colors.porcentaje.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.porcentaje.background
          }
        },
      },


      //ejes independientes
      {
        //id: 13,
        alignTicks: false,
        gridLineWidth: 0,
        //softMax: 30,
        gridLineColor: 'transparent',
        title: {
          text: 'Milimetros de Agua (ET)(mm)',
          style: {
            //color: colors.etc.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.etc.background
          }
        },
      },



      {
        //id: 14,
        alignTicks: false,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        title: {
          text: 'grados dia',
          style: {
            //color: colors.gd.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.gd.background
          }
        },
      },

      //ejes independientes
      {
        //id: 15,
        alignTicks: false,
        gridLineWidth: 0,
        softMax: 30,
        gridLineColor: 'transparent',
        title: {
          text: 'mmol/m2s',
          style: {
            //color: colors.porometro.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.porometro.background
          }
        },
      },


      {
        //id:16,
        alignTicks: false,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        title: {
          text: 'Gramos (gr)',
          style: {
            //color: colors.gramos.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.gramos.background
          }
        },
        opposite: true,
      },

      {
        //id: 17,
        alignTicks: false,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        title: {
          text: 'Calibre Milimetros(mm)',
          style: {
            //color: colors.calibre.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.calibre.background
          }
        },
      },

      {
        //id: 18,
        alignTicks: false,
        gridLineWidth: 0,
        //softMax: 30,
        gridLineColor: 'transparent',
        title: {
          text: 'Litros de agua',
          style: {
            //color: colors.etc.background
          }
        },
        labels: {
          format: '{value} lts',
          style: {
            //color: colors.etc.background
          }
        },
      },

      {
        //id: 19,
        alignTicks: false,
        gridLineWidth: 0,
        //softMax: 30,
        gridLineColor: 'transparent',
        title: {
          text: 'Coeficiente',
          style: {
            //color: colors.temperatura.background
          }
        },
        labels: {
          format: '{value}',
          style: {
            //color: colors.temperatura.background
          }
        },
      },
    ];










    var formatter = function (chart) {
      if(this.points !== undefined && this.points.length>0){
        var tooltip     = this;
        var fechaMoment = moment(tooltip.x);
        var fecha       = "";

        if (fechaMoment.isValid() && typeof tooltip.x != "string") {
          //if(chart.chart.options.showTime){
          fecha = fechaMoment.format(" D [de] MMM, YYYY, HH:mm");
          //}else{
          //fecha = fechaMoment.format(" D [de] MMM, YYYY");
          //}
        }else{
          fecha = tooltip.x;
        }


        // Add all series
        var pre                 = '';
        var sub                 = '';
        var contentTable        = '';
        var moreDate            = null;
        var temporadaActual     = temporadaFac.getActiva();
        var periodoActual       = temporadaActual.periodo;
        var temporadaAnterior   = temporadaFac.getAnteriorActiva();
        var periodoAnterior     = temporadaAnterior.periodo;

        Highcharts.each(tooltip.points, function (point) {
          if (angular.isDefined(point.series.tooltipOptions.pointFormatter)) {
            contentTable += point.series.tooltipOptions.pointFormatter.call(tooltip);
          }else{
            var moreCol = '<td></td>';


            //if (chart.chart.options.showComparison == true) {
            //   var comparisonData = 0;
            //   var selectedData = 0;
            //   var comparisonPointData = null;
            //   Highcharts.each(point.series.data, function(pointData) {
            //     //si el periodo seleccionado es el actual, comparar con el anterior
            //     if (pointData.category == periodoAnterior && point.x == periodoActual) {
            //       comparisonPointData = pointData;
            //     }
            //
            //     if (pointData.category == periodoActual && point.x != periodoActual) {
            //       comparisonPointData = pointData;
            //     }
            //   });
            //
            //   Highcharts.each(point.series.data, function(pointData) {
            //     if (pointData == point.point && comparisonPointData != null) {
            //       selectedData   = point.y;
            //       comparisonData = comparisonPointData.y;
            //       if (comparisonData !== undefined) {
            //         var diff      = _.round(selectedData -comparisonData , 2)
            //         var classDiff = diff >= 0 ? "positive":"negative";
            //         sub = point.series.tooltipOptions.valueSuffix || '';
            //         var diffPorcentaje = _.round((Math.abs(selectedData - comparisonData) / selectedData) * 100, 2);
            //         moreCol       = '<td class= "'+classDiff+'"><span> <span class="diff">'+diff+sub+' </span> ('+diffPorcentaje+'%)</span></td>';
            //         moreDate      = comparisonPointData.category;
            //       }
            //     }
            //   });
            // }

            var series = point.series;
            if(series.tooltipOptions.enabled){
              pre = point.series.tooltipOptions.valuePreffix || '';
              sub = point.series.tooltipOptions.valueSuffix || '';
              var icon = '<i class="fa fa-circle" aria-hidden="true"></i>';

              if (point.series.userOptions.type == "column") {
                icon = '<i class="fa fa-square" aria-hidden="true"></i>';
              }
              if (point.series.userOptions.type == "errorbar") {
                icon = '<i class="fa fa-caret-up" aria-hidden="true"></i>';
                contentTable += '<tr class="hc-dispersion"><td><span style="color:' + series.color + '">'+
                '<span class="char-empty"></span>'+
                icon+'</span> ' + series.userOptions.nameMax +""+
                ': </td><td style="white-space:nowrap; font-weight: bold">'+
                pre + point.point.high + sub + '</td>' +
                '</tr>';

                icon = '<i class="fa fa-caret-down" aria-hidden="true"></i>';
                contentTable += '<tr class="hc-dispersion"><td><span style="color:' + series.color + '">'+
                '<span class="char-empty"></span>'+
                icon+'</span> ' + series.userOptions.nameMin +""+
                ': </td><td style="white-space:nowrap; font-weight: bold">'+
                pre + point.point.low + sub + '</td>' +
                '</tr>';
              }else if (point.series.userOptions.type == "arearange") {
                contentTable += '<tr><td><span style="color:' + series.color + '">'+icon+'</span> ' + series.name +
                ': </td><td style="white-space:nowrap; font-weight: bold">'+
                pre + point.point.low +" - " + point.point.high + sub + '</td>' +
                moreCol +
                '</tr>';
              }else{
                contentTable += '<tr><td><span style="color:' + series.color + '">'+icon+'</span> ' + series.name +
                ': </td><td style="white-space:nowrap; font-weight: bold">'+
                pre + point.y + sub + '</td>' +
                moreCol +
                '</tr>';
              }
            }

          }
        });

        var ret = "";
        if (chart.chart.options.showComparison == true) {
          // ret += '<table>';
          // ret += '<tr class="table-dates"><th></th><th>'+fecha+'</th><th>'+moreDate +'</th></tr>';
        }else{
          ret += '<span class="tooltip-date">' + fecha + '</span>';
          ret += '<table>';
        }
        ret += contentTable;
        ret += '</table>';

        return ret;
      }else{
        var s = '<b>' + moment(this.x).format(" D [de] MMM, YYYY") + '</b>';
        s +='<br/><span>'+this.point.text+'</span>';
        return '<div class="tooltip-msg">'+s+'</div>';
      }
    };










    var multiChart = {
      navigator:{},
      chart: {
        type: 'column',
        zoomType: 'x',
        animation: false,
        printWidth : 1000,
        events: {
          beforePrint: function () {
            this.oldhasUserSize = this.hasUserSize;
            this.resetParams = [this.chartWidth, this.chartHeight, false];
            this.setSize(990, 400, false);
          },
          afterPrint: function () {
            this.setSize.apply(this, this.resetParams);
            this.hasUserSize = this.oldhasUserSize;
          },
          redraw: function(){
            console.log("redraw");
          },
        }
      },
      annotations:[],
      tooltip: {
        formatter  : formatter,
        shared     : true,
        crosshair  : true,
        useHTML    : true,
        positioner : function () {
          return { x: 80, y: 0 };
        },
        xDateFormat: '%e de  %B, %Y'
      },

      title: {},

      legend : {
        enabled       : true,
        verticalAlign : 'bottom',
        borderWidth   : 1,
        borderColor   : "#cfd8dc", //blue grey 100
        labelFormat   : "<span class='legend-text'>{name}</span>",
        useHTML       : true,
        symbolPadding : 0,
        symbolWidth   : 15,
        padding       : 10
      },




      exporting:{
        sourceWidth   : 900,
        sourceHeight  : 450,
        printMaxWidth : 1200,
        scale         : 3,
        chartOptions  : {
          plotOptions : {
            series : {
              dataLabels : {
                allowOverlap: true
              }
            }
          }
        },
        buttons: {
          customButton:{
            x         : 0,
            y         : 0,
            width     : 24,
            height    : 24,
            symbol    : "download",
            symbolX   : 13,
            symbolY   : 13,
            symbolFill: "#546e7a",
            onclick   : function () {
              console.log("test in");
              var filename = "grafico - "+this.userOptions.title.text;
              _.forEach(this.options.yAxis, function(s){
                if(s.exporting){
                  s.respaldo = _.cloneDeep(s);
                  s = _.merge(s, s.exporting);
                }
              })
              this.exportChart({
                filename: filename
              });

              this.options.yAxis = _.map(this.options.yAxis, function(s){
                return s.respaldo || s;
              })
              console.log("test");
            }
          },
          contextButton: {
            enabled:false,
            //https://stackoverflow.com/questions/25232921/disable-pdf-and-svg-download-options-in-highcharts
            menuItems: [{
              textKey: 'downloadPNG',
              onclick: function () {
                this.exportChart();
              }
            }, ]

          }
        },
      },
      //},




      xAxis: {
        crosshair: true,
        type: 'datetime',
        dateTimeLabelFormats: {
          day: '%e de %b'
        },
        labels:{y:20},
        plotBands: [],
        plotLines: []
      },

      yAxis: formatYAxis(yAxisConfig),

      series:[],

      plotOptions:{
        datalabels : {
          allowoverlap: true
        },
        series: {
          animation: false,
          connectNulls: true
        },
        // pie: {
        //   dataLabels: {
        //     enabled: true,
        //     distance: -50,
        //     style: {
        //       fontWeight: 'bold',
        //       color: 'white'
        //     }
        //   },
        //   startAngle: -90,
        //   endAngle: 90,
        //   center: ['50%', '75%']
        // },


        marker:{
          enabled: true,
          symbol:'circle',
          radius: 2
        },
      },

      func : function (chart) {


        $('.toggle-legend').click(function () {
          var legend = chart.legend;
          var w = chart.chartWidth;
          var h = chart.chartHeight;
          var x = legend.legendHeight;
          if(legend.display) {
            legend.group.hide();
            legend.display = false;
          } else {
            legend.group.show();
            legend.display = true;
          }
          chart.redraw()

        });
        $rootScope.$on('highcharts.redraw', function () {
          $timeout(function () {
            chart.redraw();
          }, 100);
        });


      } ,
      title: {
        text: '',
        style:{
          color:"#212121"
        }
      },
      subtitle:{
        text: '',
        style:{
          color:"#424242"
        }
      },

      loading: false
    }













  var config = {
    debug: false,
    yAxisConfig: yAxisConfig,
    colors: colors,
    formatter: formatter,
    multiChart : multiChart







    };

    return config;
}]);


})();
